import React from 'react';

import { Wrapper } from 'components/shared';
import { StepsRepresentContainer, StyledNumber, StyledImage, StepsRepresentHeading, StepsRepresentList, StepsRepresentItem, MainText, StyledSecondHeading, AdditionalText } from './styles';
import { Icon } from 'components/shared';


function StepsRepresent() {
  return (
    <StepsRepresentContainer>
      <Wrapper>
        <StepsRepresentHeading level={2}>Apply today. It’s an easy 3-step process.</StepsRepresentHeading>
        <StyledSecondHeading>We`ve simplified the loan application process to get you funded faster</StyledSecondHeading>
        <StepsRepresentList>
          <StepsRepresentItem>
            <StyledImage><Icon icon='documentText' width='1.875' /></StyledImage>
            <StyledNumber>1</StyledNumber>
            <MainText>Choose a loan type</MainText>
            <AdditionalText>Select the loan option that best fits your investment strategy</AdditionalText>
          </StepsRepresentItem>
          <StepsRepresentItem>
            <StyledImage><Icon icon="clipboardCheck" width='1.875' /></StyledImage>
            <StyledNumber>2</StyledNumber>
            <MainText number={2}>Apply in Minutes</MainText>
            <AdditionalText>Our streamlined application process is quick and convinient</AdditionalText>
          </StepsRepresentItem>
          <StepsRepresentItem>
            <StyledImage><Icon width='1.875' icon="userTie" /></StyledImage>
            <StyledNumber>3</StyledNumber>
            <MainText number={3}>Get expertet support</MainText>
            <AdditionalText>A dedicated loan specialist will contact you to guide through the process</AdditionalText>
          </StepsRepresentItem>
        </StepsRepresentList>
      </Wrapper>
    </StepsRepresentContainer>
  );
}


export default StepsRepresent;
